import script from "./editModel.vue?vue&type=script&setup=true&lang=js"
export * from "./editModel.vue?vue&type=script&setup=true&lang=js"

import "./editModel.vue?vue&type=style&index=0&id=a6644a1e&scoped=true&lang=less"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a6644a1e"]])

export default __exports__